import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";
const FAQMaschinenbauSection = () => <FAQSectionI18n translationPrefix="industryMaschinenbau" bgClass="bg-secondary/30" />;
export default FAQMaschinenbauSection;
